import React, { useState } from "react";
import InputText from "../common/InputText";
import { useComponent } from "../common/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { useForm } from "react-hook-form";
import { resetPassword } from "../../services/apiServices";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";

const ResetPassword = () => {
  const { setCurrentComponent, onClose } = useComponent();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  // Extract token from URL query parameters
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    trigger,
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const payload = {
        token: token,
        password: data?.password,
      };
      const response = await resetPassword(payload);
      if (response?.data?.statusCode == 200) {
        // Remove token from URL
        navigate(window.location.pathname, { replace: true });
        toast.success(
          response?.data?.message || t("reset_success"),
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
        onClose(setCurrentComponent, "signIn");
        reset();
      } else {
        toast.error(
          response?.data?.message || t("reset_failed"),
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
      }
    } catch (error) {
      console.warn("error coming in reset password: ", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <h2 className="text-2xl text-primary-text font-semibold text-center">
        {t("reset_title")}
      </h2>

      <h5 className="text-center mt-2 text-lg text-[#5D5D5D] font-medium">
        {t("reset_subtitle")}
      </h5>
      <form onSubmit={handleSubmit(onSubmit)}>
        <InputText
          title={t("reset_new_password")}
          placeholder={t("reset_new_password_placeholder")}
          type="password"
          password={true}
          {...register("password", {
            required: t("reset_password_required"),
            minLength: {
              value: 6,
              message: t("reset_password_minlength"),
            },
          })}
          error={errors.password?.message}
          value={watch("password")}
          onChange={(e) => {
            setValue("password", e.target.value);
            trigger("password");
          }}
        />

        {/* Confirm Password Input */}
        <InputText
          title={t("reset_confirm_password")}
          placeholder={t("reset_confirm_password_placeholder")}
          type="password"
          password={true}
          {...register("confirmPassword", {
            required: t("reset_confirm_password_required"),
            validate: (value) =>
              value === watch("password") || t("reset_passwords_not_match"),
          })}
          error={errors.confirmPassword?.message}
          value={watch("confirmPassword")}
          onChange={(e) => {
            setValue("confirmPassword", e.target.value);
            trigger("confirmPassword");
          }}
        />

        <div className="mt-4 text-center">
          <button
            type="submit"
            className="w-full text-base bg-red-600 text-white p-3 rounded-[121px] font-semibold"
            disabled={loading}
          >
            {loading ? <ClipLoader size={20} color="#fff" /> : t("reset_continue")}
          </button>

          <button
            onClick={() => setCurrentComponent("signIn")}
            className="text-[#5D5D5D] text-base text-center mt-6 font-semibold"
            type="button"
          >
            {t("reset_back")}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ResetPassword;
